export const CONSENT_CATEGORIES = [
  'necessary',
  'preferences',
  'analytics',
  'marketing',
] as const;

export const OPTIONAL_CONSENT_CATEGORIES = [
  'preferences',
  'analytics',
  'marketing',
] as const;

export const CONSENT_COOKIE_NAME = 'goksima_consent';
export const CONSENT_EVENT_QUEUE_KEY = 'goksima_consent_event_queue';
export const CONSENT_STATE_SCHEMA_VERSION = 1;
export const VERSION = '0.1.0';

export function isConsentCategory(value: unknown): value is ConsentCategory {
  return (
    typeof value === 'string' &&
    (CONSENT_CATEGORIES as readonly string[]).includes(value)
  );
}

export type ConsentCategory = (typeof CONSENT_CATEGORIES)[number];
export type OptionalConsentCategory =
  (typeof OPTIONAL_CONSENT_CATEGORIES)[number];

